import { createAction } from 'redux-actions';
export const setContratante = createAction('SET_CONTRATANTE_COTIZACION');

export const setParametrosPago = createAction('SET_PARAMETROS_PAGO');

export const setBanderaPrimerPago = createAction('SET_BANDERA_PRIMER_PAGO_CVV');
